<button mat-icon-button (click)="onClick()">
  <mat-icon [ngClass]="starColor()">{{ starred ? 'star' : 'star_outline' }}</mat-icon>
</button>
